import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { AccountState } from '../store/account-reducer'
import { UserState } from '../store/user-reducer'
import { GraphQLState } from '../store/graphql-reducer'
import sectionsData from '../static-copy/onboarding-section-data.json'

export default function useOnboarding(): {
  fullOnboardingSections: OnboardingSection[]
  setFullOnboardingSections: any
} {
  const {
    graphql: { currentUser },
    account: { accountOnboardingSections },
    user: { userOnboardingSections },
  }: {
    graphql: GraphQLState
    account: AccountState
    user: UserState
  } = useSelector((s: any): any => s)

  const userPermission = currentUser?.currentAccountPermission || ''

  const [fullOnboardingSections, setFullOnboardingSections] = useState<any>(
    null,
  )

  useEffect(() => {
    if (
      userPermission !== '' &&
      (userOnboardingSections !== null || accountOnboardingSections !== null)
    ) {
      const isAdminUser =
        userPermission === 'admin' || userPermission === 'support'

      let formattedSections: OnboardingSection[] = []
      if (Array.isArray(userOnboardingSections)) {
        formattedSections.push(...userOnboardingSections)
      }
      if (Array.isArray(accountOnboardingSections)) {
        formattedSections.push(...accountOnboardingSections)
      }

      // Section must appear in JSON file to populate content
      formattedSections = formattedSections
        .filter((section) => sectionsData[section.onboardingSectionID])
        .sort((a, b) => {
          return (
            sectionsData[a.onboardingSectionID].position -
            sectionsData[b.onboardingSectionID].position
          )
        })

      setFullOnboardingSections(() => {
        return isAdminUser
          ? formattedSections
          : formattedSections.filter(
              (section) => !sectionsData[section.onboardingSectionID].isAdmin,
            )
      })
    }
  }, [userPermission, userOnboardingSections, accountOnboardingSections])

  return {
    fullOnboardingSections,
    setFullOnboardingSections,
  }
}
